import SideNavigation from '@cloudscape-design/components/side-navigation';
import { useLocation, useNavigate } from 'react-router-dom';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <SideNavigation
      activeHref={location.pathname}
      header={{
        href: '/storage-inventory',
        text: 'InfraSys Storage Inventory',
      }}
      onFollow={(event) => {
        if (!event.detail.external) {
          event.preventDefault();
          navigate(event.detail.href);
        }
      }}
      items={[
        { type: 'link', text: 'Storage Inventory', href: '/storage-inventory' },
        { type: 'link', text: 'Backend / Dev Info', href: '/storage-inventory/dev' },
      ]}
    />
  );
}
